<template>
  <div>
    <el-form-item
      :label="locationLabel"
      :prop="locationProp"
    >
      <div class="flex">
        <el-select
          :class="`w-${selectWidth}`"
          multiple
          filterable
          default-first-option
          value-key="criteria_id"
          v-model="target.locations"
          @change="() => onChangeLocations(target.locations)"
        >
          <el-option
            v-for="item in enumConstants.countries"
            :key="item.criteria_id"
            :label="item.name_zhcn"
            :value="item"
          >
          </el-option>
        </el-select>
        <el-button
          type="text"
          v-if="autoFill"
          @click="autoFillLocations"
          class="!ml-2"
          >自动填充</el-button
        >
      </div>
    </el-form-item>
    <el-form-item label="排除地区">
      <el-select
        :class="`w-${selectWidth}`"
        v-model="target.excludeLocations"
        multiple
        filterable
        remote
        placeholder="请输入关键词或者邮编查询"
        value-key="id"
        :loading="loading"
        @change="emitMsg"
        @keyup.enter.native="handleManualSearch"
      >
        <el-option
          v-for="item in list"
          :key="item.id"
          :label="item.fullName"
          :value="item"
        >
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item
      :label="languageLabel"
      :prop="languageProp"
      style="margin-top: 16px"
    >
      <el-select
        multiple
        :class="`w-${selectWidth}`"
        filterable
        default-first-option
        v-model="target.languages"
        @change="emitMsg"
      >
        <el-option
          v-for="languages in enumConstants.languages"
          :label="languages.nameZhcn"
          :value="languages.id"
        ></el-option>
      </el-select>
    </el-form-item>
  </div>
</template>
<script>
import debounce from 'lodash/debounce';
import { childLocations } from '@/api/google/create';
import { selectTree } from '@adCommonComponent';
export default {
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    enumConstants: {
      type: Object,
      default: () => {},
    },
    data: {
      type: Object,
      default: () => {},
    },
    locationLabel: {
      type: String,
      default: '地区',
    },
    locationProp: {
      type: String,
      default: '',
    },
    languageLabel: {
      type: String,
      default: '语言',
    },
    languageProp: {
      type: String,
      default: '',
    },
    autoFill: {
      type: Boolean,
      default: false,
    },
    currentAccount: {
      type: Object,
      default: () => {},
    },
    selectWidth: {
      type: String,
      default: 'full',
    },
  },
  components: {
    selectTree,
  },
  data() {
    return {
      target: {},
      list: [],
      loading: false,
    };
  },
  computed: {},
  created() {
    this.initData();
  },
  watch: {
    value: {
      handler(val) {
        this.initData();
      },
      deep: true,
    },
  },
  methods: {
    // 自动填充地区
    autoFillLocations() {
      let val = this.data.promoteInfo.site.countryCode;
      let countries = this.enumConstants.countries.filter((v) => v.country_code == val);
      this.$set(this.target, 'locations', countries);
      this.$set(this.target, 'excludeLocations', []); //选择地区之后清空排除地区
      this.onChangeLocations(countries);
    },
    // 修改地区
    onChangeLocations(val) {
      let locations = this.enumConstants.countries.filter((v) =>
        val.map((k) => k.country_code).includes(v.country_code),
      );
      let languagesDefault = [...new Set(locations.map((v) => v.defaultLanguageIds).flat())];
      this.$set(this.target, 'languages', languagesDefault);
      this.$set(this.target, 'excludeLocations', []); //选择地区之后清空排除地区
      this.emitMsg();
      //   this.getChildLocation(val);
    },
    // 获取子级地区
    getChildLocation: debounce(async function (params) {
      this.loading = true;
      let res = null;
      try {
        res = await childLocations(params);
      } catch {
        this.loading = false;
      }
      this.loading = false;
      console.log(res.data);
      this.list = res.data.concat(this.list);
    }, 500),
    // 初始化数据
    initData() {
      this.target = { ...this.value };
      this.list =
        this.value.excludeLocations?.map((v) => ({
          ...v,
          fullName: v.fullName || v.name,
        })) || [];
    },
    // 导出数据
    emitMsg() {
      this.$emit('input', this.target);
    },
    // 手动触发搜索
    handleManualSearch(event) {
      const query = event?.target?.value;
      if (query) {
        this.remoteMethod(query);
      }
    },
    remoteMethod(query) {
      if (query !== '') {
        if (this.loading) return;
        try {
          this.getChildLocation({
            codeList: this.target.locations.map((v) => v.country_code),
            accountId: this.currentAccount.id,
            keyword: query,
          });
        } catch (e) {
          this.loading = false;
        }
      } else {
        // this.list = [];
      }
    },
  },
};
</script>
<style lang="scss" scoped>
// .el-select {
//   width: 80%;
// }
</style>
